import useMediaQuery from '@mui/material/useMediaQuery'

import theme from './theme'

const BROWSER_NAMES = {
  BRAVE: 'Brave',
  FIREFOX: 'Firefox',
  OPERA: 'Opera',
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  EDGE: 'Edge',
  IE: 'Internet Explorer',
}

const getBrowserName = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('firefox') > -1) {
    return BROWSER_NAMES.FIREFOX
  } else if (userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1) {
    return BROWSER_NAMES.OPERA
  } else if (userAgent.includes('chrome') && navigator.brave !== undefined) {
    return BROWSER_NAMES.BRAVE
  } else if (
    (userAgent.indexOf('chrome') > -1 || userAgent.indexOf('crios') > -1) &&
    userAgent.indexOf('edg') === -1 &&
    userAgent.indexOf('opr') === -1
  ) {
    return BROWSER_NAMES.CHROME
  } else if (
    userAgent.indexOf('safari') > -1 &&
    userAgent.indexOf('chrome') === -1
  ) {
    return BROWSER_NAMES.SAFARI
  } else if (userAgent.indexOf('edg') > -1) {
    return BROWSER_NAMES.EDGE
  } else if (userAgent.indexOf('trident') > -1) {
    return BROWSER_NAMES.IE
  } else {
    return undefined
  }
}

// Function to detect if the user is on an desktop device
const isDesktop = () =>
  !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLowerCase(),
  )

// Function to detect if the user is on an Android device
const isAndroid = () => /Android/i.test(navigator.userAgent)

// Function to detect if the user is on an iOS device
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)

export const browser = {
  name: getBrowserName,
  isChrome: () => getBrowserName() === BROWSER_NAMES.CHROME,
  isEdge: () => getBrowserName() === BROWSER_NAMES.EDGE,
  isDesktop,
  isAndroid,
  isIOS,
}

export const useIsDesktop = () => useMediaQuery(theme.breakpoints.up('md'))
